import { TagList } from "../tags/tag-list";
import { faHeart as faHeartUnchecked, IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { CourseStatus } from "./course-status";

export interface Course {
  id: string,
  courseName: string,
  courseShortDescription: string,
  courseDescription: string,
  materialId: { id: string, disabled?: boolean }[],
  languageId: number,
  tagId: string[],
  courseThumbnailFileId: number,
  courseThumbnailName: string,
  courseStatus: number,
  coursePrograms: number[],
  isReplaced: boolean,
  replacementCourseId: string,
  courseType:number
}

export function AddCourseDefaultValues(): Course {
  return {
    id: '',
    courseName: '',
    courseShortDescription: '',
    courseDescription: '',
    materialId: [],
    languageId: 0,
    tagId: [],
    courseThumbnailFileId: 0,
    courseThumbnailName:'',
    courseStatus: CourseStatus.DRAFT,
    coursePrograms: [],
    isReplaced: false,
    replacementCourseId: '',
    courseType:0
  }
}

export interface ViewCourse {
  id: string,
  courseName: string,
  courseId: string,
  courseShortDescription: string,
  courseDescription: string,
  coursePrograms: string,
  courseCreated: string,
  courseRetirement: string,
  courseRetirementAccessUntil: string,
  language: string,
  tags: string,
  enrollment: string,
  materialList: any[],
  tagList: TagList[],
  courseThumbnailIconId: number,
  courseStatus: string,
  replacementId: string,
  replacementCourseId: string,
  isEditable: boolean,
  isDeletable: boolean,
  participantCourseStatus: string,
  isResumeCourseVisible: boolean,
  isStartCourseVisible: boolean,
  isFavourite: boolean,
  enrollmentStatus: string,
  enrollmentClass: string,
  retired: any;
  favoriteFlag: boolean,
  favoriteIcon: IconDefinition,
  courseStatusId:number,
  courseType: string,
}

export function ViewCourseDefaultValues(): ViewCourse {
  return {
    id: '',
    courseName: '',
    courseId: '',
    courseShortDescription: '',
    courseDescription: '',
    coursePrograms: '',
    courseCreated: '',
    courseRetirement: '',
    courseRetirementAccessUntil: '',
    language: '',
    tags: '',
    enrollment: '',
    materialList: [],
    tagList: [],
    courseThumbnailIconId: 0,
    courseStatus: '',
    replacementId: '',
    replacementCourseId: '',
    isEditable: false,
    isDeletable: false,
    participantCourseStatus: '',
    isResumeCourseVisible: false,
    isStartCourseVisible: false,
    isFavourite: false,
    enrollmentStatus: '',
    enrollmentClass: '',
    retired: false,
    favoriteFlag: false,
    favoriteIcon: faHeartUnchecked,
    courseStatusId:0,
    courseType:''
  }
}

